import type { ErrorContext } from '@/libs/datadog';

/**
 * Session-scoped key that records whether we have already attempted a
 * full-page reload to recover from a failed dynamic import. Scoped to the
 * tab so a refresh in one tab does not silence failures in others.
 */
export const RELOAD_FLAG_KEY = 'lazyWithRetry:reloaded';

/**
 * Datadog context for a first dynamic-import failure, before the recovery
 * reload. This path is otherwise silent — no error reaches an ErrorBoundary —
 * so reporting it keeps the chunk-load failure (and the reload rate) traceable.
 */
export const RELOAD_ERROR_CONTEXT: ErrorContext = {
  source: 'lazyWithRetry',
  recovery: 'reload'
};

/**
 * Datadog context for a dynamic-import failure that persists after the reload.
 * The error is also re-thrown to the nearest ErrorBoundary; this labels it as a
 * terminal chunk-load failure for filtering/alerting in RUM.
 */
export const RETHROW_ERROR_CONTEXT: ErrorContext = {
  source: 'lazyWithRetry',
  recovery: 'rethrow'
};
